import css from "styled-jsx/css";
import { colors, grid } from "../constants";

export default css`
  :global(.card-cont) {
    padding: 0 !important;

    .shadow {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: linear-gradient(
        0deg,
        rgba(0, 0, 0, 0.9) 0%,
        rgba(0, 0, 0, 0.5) 33%,
        rgba(0, 0, 0, 0) 44%,
        rgba(0, 0, 0, 0) 100%
      );
    }
  }

  .streaming-card {
    width: 15.25rem;
    height: 24.5rem;
    border-radius: 1rem;
    display: flex;
    align-items: flex-end;

    .card-content {
      padding: 1rem;
      flex-grow: 1;
      position: relative;

      :global(.title) {
        margin-bottom: 1rem;
      }
      :global(.text) {
        margin-top: 0.5rem;
      }
      .separator {
        height: 1px;
        margin-top: 1rem;
        margin-bottom: 0.5rem;
        background-color: ${colors.color_gp__grey4};

        display: block;
        width: 100%;
      }

      :global(.price-container) {
        .container-text-price {
          display: inline-flex;
        }
      }

      :global(.button-añadir) {
        display: none;
      }
    }
  }

  // Tablet
  @media screen and (min-width: ${grid.breakpoint_sm}px) {
    .streaming-card {
      width: min(29vw, 480px);
      height: 359.61px;

      .card-content {
        :global(.button-añadir) {
          display: inline-block;
          line-height: 1.8rem;
        }
        :global(.price-container) {
          .container-text-price {
            display: flex;
            align-items: center;
          }
        }
      }
    }
  }

  // Desktop
  @media screen and (min-width: ${grid.breakpoint_md}px) {
    .streaming-card {
      width: min(29vw, 480px);
      height: 359.61px;

      .card-content {
        padding: 1.5rem;

        .separator {
          margin-bottom: 1rem;
        }

        :global(.price-container) {
          .container-text-price {
            display: inline-flex;
          }
        }

        :global(.button-añadir) {
          display: none;
        }
      }
    }
  }

  @media screen and (min-width: 1400px) {
    .streaming-card {
      width: min(28vw, 480px);
    }
  }
`;
